import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { chatImagesSelector } from '../../selectors/chatImagesSelector';
import { userProfileStatusSelector } from '../../selectors/userProfile';
import { EUserCardTab } from '../../components/UserCard/UserCardSwitcher/types';
import { ERequestApiStatus } from '../../types/appState';

const USER_CARD_SWITCHER_TABS = [EUserCardTab.About, EUserCardTab.Photos];

// Статусы, при которых вкладке «О клиенте» есть что показать: данные, лоадер или ошибку.
// При Empty профиль загрузился пустым, и вкладку показывать не нужно.
const ABOUT_TAB_VISIBLE_STATUSES = [ERequestApiStatus.Succeed, ERequestApiStatus.Pending, ERequestApiStatus.Failed];

/**
 * Определяет, какие вкладки карточки пользователя нужно показывать, и управляет активной вкладкой.
 * Вкладка выводится только если у неё есть содержимое.
 */
export const useUserCardTabs = () => {
  const images = useSelector(chatImagesSelector);
  const status = useSelector(userProfileStatusSelector);

  const isAboutTabVisible = !!status && ABOUT_TAB_VISIBLE_STATUSES.includes(status);
  const hasPhotosContent = !!images?.files?.length;

  const tabs = useMemo(
    () => USER_CARD_SWITCHER_TABS.filter(tab => (tab === EUserCardTab.About ? isAboutTabVisible : hasPhotosContent)),
    [isAboutTabVisible, hasPhotosContent],
  );

  const [activeTab, setActiveTab] = useState<EUserCardTab | null>(null);

  const resolvedActiveTab = activeTab && tabs.includes(activeTab) ? activeTab : (tabs[0] ?? null);

  return { tabs, activeTab: resolvedActiveTab, setActiveTab };
};
